import { render } from "./customer-edit.vue?vue&type=template&id=d0ecef00&scoped=true"
import script from "./customer-edit.vue?vue&type=script&lang=js"
export * from "./customer-edit.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d0ecef00"

export default script